import React from "react";
import { Comment } from "semantic-ui-react";
import {
  Badge,
  Theme,
} from "@120wateraudit/waterworks";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Activity } from "src/types/Activity";
import { formatDateTime } from "src/utils/format";
import { StatusBadge } from "src/modules/Submissions/StatusBadge";

interface Props {
  activities: Activity[];
  activityFilter: string;
  onClose: () => void;
}

const CommentSection: React.FC<Props> = ({
  activities,
  activityFilter,
  onClose,
}) => {
  return (
    <Comment.Group
      style={{ maxWidth: "100%", overflowY: "auto", height: "50vh" }}
    >
      {activities
        .filter((a) =>
          activityFilter === "all" ? true : a.type === activityFilter,
        )
        .reverse()
        .map((activity) => {
          const capitalizedFirstLetter: string = activity.type
            .charAt(0)
            .toUpperCase();
          const remainingWord: string = activity.type.slice(1);
          const activityName: string = `${capitalizedFirstLetter}${remainingWord}`;

          return (
            <Comment key={activity.id}>
              <Comment.Content>
                <Comment.Author>{activity.submittedByName}</Comment.Author>
                <Comment.Metadata style={{ marginLeft: "0px" }}>
                  <div style={{ color: "black" }}>
                    {formatDateTime(activity.timestamp)}
                  </div>
                  <div>
                    <Badge
                      backgroundColor={
                        activity.type === "notification"
                          ? Theme.palette.badgePendingBackground
                          : Theme.palette.badgeSuccessBackground
                      }
                      color={
                        activity.type === "notification"
                          ? Theme.palette.badgePendingText
                          : Theme.palette.badgeSuccessText
                      }
                    >
                      {activityName}
                    </Badge>
                  </div>
                  <div>
                    <Badge
                      backgroundColor={
                        activity.originType === "pws"
                          ? Theme.palette.badgePendingBackground
                          : Theme.palette.badgeSuccessBackground
                      }
                      color={
                        activity.originType === "pws"
                          ? Theme.palette.badgePendingText
                          : Theme.palette.badgeSuccessText
                      }
                    >
                      {activity.originName}
                    </Badge>
                  </div>
                  <div>
                    <StatusBadge status={activity.submissionStatus} />
                  </div>
                </Comment.Metadata>
                <Comment.Text>
                  <div style={{ fontWeight: "bold" }}>{activity.comment}</div>
                </Comment.Text>
                <Comment.Actions>
                  <StyledCommentLink
                    onClick={onClose}
                    to={`/submissions/${activity.submissionId}`}
                  >
                    Go to Submission
                  </StyledCommentLink>
                </Comment.Actions>
              </Comment.Content>
            </Comment>
          );
        })}
    </Comment.Group>
  );
};

export default CommentSection;

const StyledCommentLink = styled(Link)`
  color: ${Theme.palette.secondary} !important;
  &:hover {
    opacity: 0.9;
  }
`;
